/**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */
export function ccount(value, character) {
  var source = String(value);

  if (typeof character !== 'string') {
    throw new TypeError('Expected character');
  }

  var count = 0;
  var index = source.indexOf(character);

  while (index !== -1) {
    count++;
    index = source.indexOf(character, index + character.length);
  }

  return count;
}